<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <template @dblclick="dialog = true" v-slot:activator="{ on }">
      <v-list-item @dblclick="dialog = on" three-line :class="color">
        <v-list-item-avatar>
          <img src="https://randomuser.me/api/portraits/lego/7.jpg" />
        </v-list-item-avatar>

        <v-list-item-content class="text-capitalize white--text">
          <v-list-item-title>
            <slot name="FullName"></slot>
          </v-list-item-title>
          <v-list-item-subtitle class="white--text">
            <slot name="userName"></slot>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="white--text">
            <slot name="userType"></slot>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-toolbar color="teal">
        <v-toolbar-title>Change password</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text :disabled="clicked" @click="close" dark color=""
          >close</v-btn
        >
      </v-toolbar>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="8">
            <p v-if="ErrMessage" v-html="ErrMessage" class="red--text"></p>
          </v-col>
          <v-col cols="8">
            <v-form ref="ChangePassForm">
              <v-text-field
                type="password"
                validate-on-blur
                v-model="Passwords.OldPass"
                :rules="[requiredFild]"
                name="OldPass"
                label="Old Password"
                id="OldPassid"
              ></v-text-field>
              <v-text-field
                type="password"
                validate-on-blur
                v-model="Passwords.NewPass"
                :rules="[requiredFild, lengthPass]"
                name="NewPass"
                label="New Password"
                id="newPassid"
              ></v-text-field>
              <v-text-field
                type="password"
                validate-on-blur
                v-model="Passwords.ConfirmPass"
                :rules="[requiredFild, MutchPassword]"
                name="ConfPass"
                label="Confirm Password"
                id="ConfPassid"
              ></v-text-field>
              <v-btn
                :loading="clicked"
                block
                @click="OnchangePass"
                color="success"
                >Change Password</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  //   props: { dialog: { type: Boolean, required: true } },
  props: {
    color: [String],
  },
  data() {
    return {
      ErrMessage: "",
      clicked: false,
      dialog: false,
      Passwords: { OldPass: "", NewPass: "", ConfirmPass: "" },
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.close();
    },
  },
  methods: {
    OnchangePass() {
      this.ErrMessage = "";
      if (this.$refs.ChangePassForm.validate()) {
        this.clicked = true;

        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/users/changepass",
            data: {
              Passwords: this.Passwords,
            },
          })
          .then(() => {
            this.clicked = false;
            // console.log(value);
            this.close();
          })
          .catch(error => {
            this.clicked = false;
            // console.log(error);
            if (error.response) this.ErrMessage = error.response.data;
          });
      }
    },
    close() {
      this.dialog = false;
      this.ErrMessage = "";
      this.$refs.ChangePassForm.reset();
    },
    requiredFild(v) {
      if (!v) return "this is required";
      else return true;
    },
    MutchPassword() {
      if (this.Passwords.NewPass != this.Passwords.ConfirmPass)
        return "passwords in not match";
      else return true;
    },
    lengthPass(v) {
      if (v && v.length < 6) return "Min length is 6";
      else return true;
    },
  },
};
</script>
